export const parseCurrencyString = (input: string) => {
  if (input) {
    const currencyMatch = input?.match(/^[^\d.-]+/);
    const symbolOrCode = currencyMatch ? currencyMatch[0]?.trim() : '';
    const cleanedNumber = input?.replace(/[^0-9.-]+/g, '');
    const parsedAmount = parseFloat(cleanedNumber);

    // Check if parsedAmount is a float and apply toFixed(2) if true
    const amount = Number.isNaN(parsedAmount)
      ? '-'
      : (parsedAmount % 1 !== 0 ? parsedAmount.toFixed(2) : parsedAmount.toString());

    return {
      symbolOrCode,
      amount,
    };
  } else {
    return {
      amount: '-',
    };
  }
};